// #256. One implementation shared by the desktop DetailPanel and the mobile
// detail sheet. PurchasingQueuePage.js already carries #231's cost of the same
// block written twice; this one started shared. Extracted to its own file at
// Session 79.14c.
//
// Renders only for a request that cleared spend approval — denial also lands on
// status 'approved' but nulls approved_at, so approved_at is the separator.

import React from 'react';
import { fmtDate } from '../../lib/utils';

export default function ApprovedToOrderBanner({ req, compact }) {
  if (!req || req.status !== 'approved' || req.approved_at == null) return null;
  const amount = req.approved_amount != null ? parseFloat(req.approved_amount) : null;
  return (
    <div style={{ background: '#E8F5E9', border: '1px solid #A5D6A7', borderRadius: 8, padding: compact ? '8px 10px' : '10px 12px', marginBottom: compact ? 12 : 16 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: '#1B5E20' }}>Approved to order</div>
      <div style={{ fontSize: 12, color: '#2E7D32', marginTop: 4, lineHeight: 1.5 }}>
        {amount != null ? `$${amount.toFixed(2)} cleared` : 'Cleared'} by {req.approver?.full_name || 'an approver'} on {fmtDate(req.approved_at)}
        {req.approval_threshold_amount != null ? `, against the $${parseFloat(req.approval_threshold_amount).toFixed(2)} threshold` : ''}.
      </div>
      {amount != null && (
        <div style={{ fontSize: 12, color: '#2E7D32', marginTop: 6, paddingTop: 6, borderTop: '1px solid #A5D6A7', lineHeight: 1.5 }}>
          Prices are held from approval. Going above ${amount.toFixed(2)} sends it back for approval.
        </div>
      )}
    </div>
  );
}
